<template>
  <div class="footer">
    <div class="footer-main">
      <div class="top flex justify-between">
        <div class="left flex items-start">
          <img class="w-[160px] h-[160px] mr-[80px]" :src="logo" alt="" />
          <div class="message">
            <div class="label">{{ t("shell.charlotteFooter.hongKong") }}:</div>
            <div class="value">
              {{ t("shell.charlotteFooter.addressDetail1") }}
            </div>
            <div class="value">
              {{ t("shell.charlotteFooter.addressDetail2") }}
            </div>
            <div class="label mt-[24px]">
              {{ t("shell.charlotteFooter.phone") }}:
            </div>
            <div class="value">+852 2110 6070</div>

            <div class="label mt-[24px]">
              {{ t("shell.charlotteFooter.singapore") }}:
            </div>
            <div class="value">
              {{ t("shell.charlotteFooter.singaporeAddress") }}
            </div>

            <div class="label mt-[24px]">
              {{ t("shell.charlotteFooter.phone") }}:
            </div>
            <div class="value">+65 6672 7778</div>

            <div class="value !mt-[24px]">
              <em>{{ t("shell.charlotteFooter.addressDetail3") }}</em>
            </div>

            <div class="label mt-[24px]">
              {{ t("shell.charlotteFooter.email") }}:
            </div>
            <div class="value">info@charlottetravel.com</div>

            <div class="value-contact mt-[24px]">
              {{ t("shell.charlotteFooter.contactUsHere") }}:
            </div>
            <div class="contact flex items-center mt-[12px]">
              <img
                class="w-[40px] h-[40px] mr-[12px] cursor-pointer"
                v-for="(item, index) in contactImgs"
                @click="handleLinkClick(item.link)"
                :key="index"
                :src="item.src"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="right flex justify-between">
          <div class="left flex flex-col mr-[130px]">
            <span
              v-for="(item, index) in linksLeft"
              :key="index + 'left'"
              @click="handleLinkClick(item.link)"
              >{{ item.title }}</span
            >
          </div>
          <div class="right flex flex-col">
            <span
              v-for="(item, index) in linksRight"
              :key="index + 'right'"
              @click="handleLinkClick(item.link)"
              >{{ item.title }}</span
            >
          </div>
        </div>
      </div>
      <div class="bottom flex justify-between mt-[46px] pt-[16px]">
        <div class="left">
          {{ copyAndPrivacyAndTerms.copy.label }}
        </div>
        <div class="right">
          <span class="mr-[24px]" @click="handleShowPrivacy">{{
            copyAndPrivacyAndTerms.privacy.label
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <my-drawer
    v-model="showDrawer"
    :title="drawerTitle"
    :content="drawerContent"
  />
</template>

<script setup lang="ts" name="Footer">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import { getArticleDetail } from "@/api/rest/common";
import MyDrawer from "@/distributions/consumer/y/components/Drawer/index.vue";
import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";
import { useDeploymentStoreHook } from "@/store/modules/deployment";
import { useUserStoreHook } from "@/store/modules/user";
const yChannelStore = useYChannelStoreHook();
const deploymentStore = useDeploymentStoreHook();
const showDrawer = ref(false);
const drawerTitle = ref("");
const drawerContent = ref("");
const userStore = useUserStoreHook();

const logo = computed(() => {
  return yChannelStore.configs?.pages?.Index?.leftLogoUrl;
});
const { t } = useI18n();
const contactImgs = [
  {
    src: "https://uploads.ytripos.com/uploaded/FjDTCZjZm7aQ4uMfKnMzBUBPSxqP/facebook@2x.png?imageView2/2/w/300",
    link: "https://www.facebook.com/CharlotteTravelHK/?fref=ts"
  },
  {
    src: "https://uploads.ytripos.com/uploaded/Finaf8pln3EsJJmcbMU74bmSKAM6/instagram@2x.png?imageView2/2/w/300",
    link: "https://www.instagram.com/charlottetravel.asia/"
  },
  {
    src: "https://uploads.ytripos.com/uploaded/Fl2CUmL6yiQOrCq9jgGRDfKFWW3n/linked-in@2x.png?imageView2/2/w/300",
    link: "https://www.linkedin.com/uas/login?session_redirect=%2Fcompany%2F2038909%3Ftrk%3Dtyah%26trkInfo%3DclickedVertical%253Acompany%252CclickedEntityId%253A2038909%252Cidx%253A3-1-6%252C"
  },
  {
    src: "https://uploads.ytripos.com/uploaded/Flw7n0dRiHL2HLX168ZaIBa9j7VZ/whatsapp@2x.png?imageView2/2/w/300",
    link: "https://api.whatsapp.com/send/?phone=85292219192&text&type=phone_number&app_absent=0"
  }
];

const linksLeft = computed(() => {
  return [
    {
      title: t("shell.charlotteFooter.linksLeft.home"),
      link: "https://charlottetravel.com/"
    },
    {
      title: t("shell.charlotteFooter.linksLeft.placeToVisit"),
      link: "https://charlottetravel.com/places-to-visit"
    },
    {
      title: t("shell.charlotteFooter.linksLeft.aboutUs"),
      link: "https://charlottetravel.com/about-us"
    },
    {
      title: t("shell.charlotteFooter.linksLeft.privacyPolicy"),
      link: "https://charlottetravel.com/privacy-policy"
    },
    {
      title: t("shell.charlotteFooter.linksLeft.termsConditions"),
      link: "https://charlottetravel.com/terms-and-conditions"
    },
    {
      title: t("shell.charlotteFooter.linksLeft.getInTouch"),
      link: "https://charlottetravel.com/"
    }
    // {
    //   title: t("shell.charlotteFooter.linksLeft.travelInsurance"),
    //   link: "https://charlottetravel.com/page/travel-insurance"
    // }
  ];
});
const linksRight = computed(() => {
  return [
    {
      title: t("shell.charlotteFooter.linksRight.destinations"),
      link: ""
    },
    {
      title: t("shell.charlotteFooter.linksRight.africa"),
      link: "https://charlottetravel.com/continent/africa"
    },
    {
      title: t("shell.charlotteFooter.linksRight.asia"),
      link: "https://charlottetravel.com/places-to-visit/asia"
    },
    {
      title: t("shell.charlotteFooter.linksRight.australasia"),
      link: "https://www.charlottetravel.com/places-to-visit/australasia-and-the-south-pacific"
    },
    {
      title: t("shell.charlotteFooter.linksRight.caribbean"),
      link: "https://charlottetravel.com/continent/caribbean"
    },
    {
      title: t("shell.charlotteFooter.linksRight.europe"),
      link: "https://charlottetravel.com/continent/europe"
    },
    {
      title: t("shell.charlotteFooter.linksRight.latinAmerica"),
      link: "https://www.charlottetravel.com/places-to-visit/latin-america"
    },
    {
      title: t("shell.charlotteFooter.linksRight.middleEast"),
      link: "https://charlottetravel.com/continent/middle-east"
    },
    {
      title: t("shell.charlotteFooter.linksRight.northAmerica"),
      link: "https://charlottetravel.com/continent/north-america"
    },
    {
      title: t("shell.charlotteFooter.linksRight.polar"),
      link: "https://charlottetravel.com/continent/polarnordic"
    },
    {
      title: t("shell.charlotteFooter.linksRight.southCentralAsia"),
      link: "https://charlottetravel.com/continent/south-central-asia"
    }
  ];
});

const copyAndPrivacyAndTerms = computed(() => {
  return {
    copy: {
      label: t("shell.charlotteFooter.copyAndPrivacyAndTerms.copy")
    },
    privacy: {
      label: t("shell.charlotteFooter.copyAndPrivacyAndTerms.privacy"),
      link: "https://charlottetravel.com/page/privacy-policy"
    },
    terms: {
      label: t("shell.charlotteFooter.copyAndPrivacyAndTerms.terms"),
      link: "https://charlottetravel.com/page/terms-conditions"
    }
  };
});

const handleLinkClick = (link: string) => {
  if (link) {
    window.open(link, "_blank");
  }
};

const handleShowPrivacy = async () => {
  const res = await getArticleDetail(
    deploymentStore.terms.privacyI18n[userStore.language] ||
      deploymentStore.terms.privacyI18n.en
  );
  drawerContent.value = res.content;
  drawerTitle.value = res.title;
  showDrawer.value = true;
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  color: #fff;
  background: #213d47;
  padding-top: 52px;
  padding-bottom: 40px;

  .footer-main {
    width: 1080px;
    margin: 0 auto 36px;

    .top {
      .left {
        .message {
          .label {
            font-weight: 400;
            font-size: 12px;
            color: #afa177;
          }
          .value {
            font-weight: 400;
            font-size: 13px;
            color: #ffffff;
            margin-top: 8px;
          }
          .value-contact {
            font-weight: 400;
            font-size: 13px;
            color: #ffffff;
          }
        }
      }
      .right {
        .left,
        .right {
          span {
            font-weight: 400;
            margin-top: 6px;
            font-size: 13px;
            color: #ffffff;
            cursor: pointer;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
    .bottom {
      border-top: rgba(238, 238, 238, 0.2) solid 1px;
      .left {
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
      }
      .right {
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
        span {
          margin-left: 20px;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
